/* eslint-disable react/prefer-stateless-function */

import React from 'react'
import MaskedInput from 'react-text-mask'

export const TextMaskCustom = props => {
  const { inputRef, ...other } = props

  return (
    <MaskedInput
      ref={inputRef}
      {...other}
      mask={[
        '(',
        /\d/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      placeholderChar={'\u2000'}
      showMask
      guide={false}
    />
  )
}

// export const MaskText = props => {
//   const { inputRef, ...other } = props

//   return (
//     <MaskedInput
//       ref={inputRef}
//       {...other}
//       mask={x => {
//         return x.match[/[A-Za-z]+/]
//       }}
//       // placeholderChar={'\u2000'}
//       showMask
//       guide={false}
//     />
//   )
// }
